module.exports = __webpack_public_path__ + "img/sx.17615fa8.gif";